import React, { createRef, useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import './FileUpload.css';

const FileUpload = ({ getDocs }) => {
    const [docs, setDocs] = useState([]);
    const [month, setMonth] = useState([])
    const dropzoneRef = createRef();

    useEffect(() => {
        getDocs(docs)
    }, [docs])

    useEffect(() => {
        const monthNames = ["Jan", "Feb", "Mar", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"], months = [];
        let today = new Date(), d, month;

        for (let i = 6; i > 0; i -= 1) {
            d = new Date(today.getFullYear(), today.getMonth() - i, 1);
            month = monthNames[d.getMonth()];
            if (i === 6 || i === 1) {
                if (!months.includes(month)) {
                    months.push(month + ' ' + today.getFullYear())
                }
            }
        }
        setMonth(months)
    }, [])

    return (
        <Dropzone ref={dropzoneRef} noClick noKeyboard accept='application/pdf'>
            {({ getRootProps, getInputProps, acceptedFiles }) => {
                return (
                    <div className="container">
                        <div {...getRootProps({ className: 'dropzone' })}>
                            <input {...getInputProps()} />
                            <p className="mb-0 mt-2 mb-2 statement">Bank Statements from {month.length && month.join(' - ')} </p>
                            {
                                acceptedFiles.length && docs.length ?
                                    <p>{acceptedFiles.length} Files Uploaded!</p> : null
                            }
                            <button type="button" onClick={() => {
                                return acceptedFiles.length !== 0 ? (acceptedFiles.splice(0, acceptedFiles.length), setDocs([])) : dropzoneRef.current !== null && dropzoneRef.current.open()
                            }} className={`mb-4 mt-2 ${acceptedFiles.length ? "removeBtn" : "uploadBtn"}`}>
                                {acceptedFiles.length ? 'REMOVE' : 'Upload'}
                            </button>
                            {acceptedFiles.length ? setDocs(acceptedFiles) : null}
                        </div>
                    </div>
                );
            }}
        </Dropzone>)
}

export default FileUpload;